import React, { useState } from 'react';
import { Phone, SquarePen, TrashIcon } from 'lucide-react';
import NotificationsList from 'features/crm/components/notifications/NotificationsList';
import EmployeeForm from 'features/company/components/employees/EmployeeForm';
import DocsList from 'features/docs/components/DocsList';
import { Tabs, Tab } from 'shared/ui/Tabs';
import DocStats from 'features/stats/pages/DocStats';
import { useLayout } from 'shared/contexts/LayoutContext';
import { useStateContext } from 'shared/contexts/ContextProvider';
import { employeeService } from 'features/company/api';

const EmployeeItem = ({ item, refreshList }) => {
  const { openModal, closeModal } = useLayout();
  const { currentColor, showToast } = useStateContext();

  const handleEditEmployee = () => {
    openModal({
      component: <EmployeeForm employee={item} />,
      title: 'Изменить сотрудник',
    });
  };

  const handleDeleteEmployee = async () => {
    const confirmDelete = window.confirm(`Вы уверены, что хотите удалить сотрудника ${item.name}?`);
    if (confirmDelete) {
      const response = await employeeService.delete(item.id);
      if (response.status === 0) {
        showToast({
          title: 'Успешно!',
          content: `Сотрудник ${item.name} удален`,
          type: 'success',
        });
        closeModal();
        refreshList ? refreshList() : null;
      }
      else {
        showToast({
          title: 'Ошибка!',
          content: response.message || 'Что-то пошло не так!',
          type: 'error',
        });
      }

    }
  }


  return (
    <>
      {/* Header Section */}
      <div className='flex justify-between items-start mb-6'>
        <div>
          <h1 className='text-xl font-semibold mb-1'>{item.name}</h1>
          <p className='text-gray-500 text-xs'>Создан {item.created}</p>
        </div>
        <div className='text-right space-x-2'>
          <button className=' text-white px-4 py-2 rounded-md hover:' style={{ backgroundColor: currentColor }} onClick={() => handleEditEmployee()}>
            <SquarePen size={16} className='mr-1' />
          </button>
          <button className=' text-white px-4 py-2 rounded-md hover: bg-red-500' onClick={() => handleDeleteEmployee()}>
            <TrashIcon size={16} className='mr-1' />
          </button>
        </div>
      </div>

      {/* Contacts Section */}
      <div className='bg-white rounded-lg shadow-sm border mb-6'>
        <div className='p-4 border-b'>
          <h2 className='font-medium text-sm'>КОНТАКТЫ</h2>
        </div>
        <div className='p-4'>
          <div className='flex items-center gap-2'>
            <Phone size={16} className='text-gray-500' />
            <a href={`tel:${item.phone}`} className='text-blue-600 text-sm'>
              {item.phone}
            </a>
          </div>
        </div>
      </div>
      {/* Recent Operations Section */}
      <div className='bg-white rounded-lg shadow-sm border'>
        <Tabs initialTab='stats'>
          <Tab key='stats' label='Статистика'>
            <DocStats employee={item.meta} />
          </Tab>
          <Tab key='docs' label='Движение товара'>
            <DocsList consultant={item} />
          </Tab>
          <Tab key='notifications' label='Уведомления'>
            <NotificationsList employee={item} />
          </Tab>
        </Tabs>
      </div>
    </>
  );
};

export default EmployeeItem;